import React from 'react';
import './ComingSoon.css';
import { FaRocket } from 'react-icons/fa'; // Font Awesome Rocket Icon

export default function ComingSoon() {
  const progress = 58;

  return (
    <div className="cs-page">
      {/* Outer frame border */}
      <div className="cs-frame" />
      
      {/* Multi-layered mountain background */}
      <div className="cs-mountains">
        <div className="cs-mountain-layer cs-mountain-back" />
        <div className="cs-mountain-layer cs-mountain-mid" />
        <div className="cs-mountain-layer cs-mountain-front" />
      </div>
      
      {/* Gradient overlays */}
      <div className="cs-gradient-overlay" />
      
      {/* Main content */}
      <div className="cs-content">
        <div className="cs-brand-mark">◉</div>
        
        <div className="cs-text-content">
          <p className="cs-subtitle">UNDER CONSTRUCTION</p>
          <h1 className="cs-title">
            <span className="cs-title-word">COMING</span>
            <span className="cs-title-word">SOON</span>
          </h1>
          <p className="cs-description">
            Something extraordinary is being crafted.<br />
            Stay tuned for the future.
          </p>
        </div>

        {/* Progress section */}
        <div className="cs-progress-section">
          <div className="cs-progress-container">
            <div className="cs-progress-bar">
              <div
                className="cs-progress-fill"
                style={{ width: `${progress}%` }}
              >
                <div className="cs-progress-glow" />
              </div>
              <div className="cs-rocket-container" style={{ left: `${progress}%` }}>
                <FaRocket className="cs-rocket" />
              </div>
            </div>
          </div>
          <div className="cs-progress-info">
            <span className="cs-progress-text">{progress}% Complete</span>
            <span className="cs-progress-eta">ETA: Q2 2025</span>
          </div>
        </div>
      </div>
      
      {/* Ambient light effects */}
      <div className="cs-ambient-light cs-ambient-light-1" />
      <div className="cs-ambient-light cs-ambient-light-2" />
    </div>
  );
}
